import { render, staticRenderFns } from "./PdfThumbnail.vue?vue&type=template&id=348dd03a&scoped=true&"
import script from "./PdfThumbnail.vue?vue&type=script&lang=ts&"
export * from "./PdfThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./PdfThumbnail.vue?vue&type=style&index=0&id=348dd03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348dd03a",
  null
  
)

export default component.exports